export enum ExceptionStatus {
    PENDING = 'pending',
    FINISHED = 'finished'
}